// Claves de localStorage que leen/escriben tanto AuthService como
// DbCompaniesService (la sesión persistida y la empresa seleccionada).
// Centralizadas aquí para que ambos servicios usen siempre el mismo nombre
// de clave y no puedan desincronizarse si alguno la renombra por su cuenta.
export const SHARED_STORAGE_KEYS = {
  authSession: 'authSession',
  companySelected: 'companySelected',
} as const;

// Estado de suplantación. Lo escribe ImpersonateService, pero AuthService
// también lo borra al cerrar sesión (clearSessionState) para que no
// sobreviva a un logout y le aparezca "Volver" al siguiente usuario.
export const IMPERSONATION_STORAGE_KEYS = {
  userId: 'impersonating_user_id',
  companyId: 'impersonating_original_company_id',
} as const;
